
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight, ArrowRight } from 'lucide-react';

export function CallToActionSection() {
  return (
    <div className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="relative bg-gradient-to-br from-card to-card/50 border border-border rounded-3xl p-12 md:p-16 text-center overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-400/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-yellow-400/5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
              Ready to transform your <span className="text-yellow-400">workflow?</span>
            </h2>
            <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
              Join thousands of businesses using atWork.ai to streamline their sales and marketing processes.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-yellow-400 text-neutral-900 hover:bg-yellow-300 text-lg px-8 py-4 rounded-full font-semibold">
                <Link to="/register" className="inline-flex items-center gap-x-3">
                  Get started for free
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </Button>
              <Button variant="outline" size="lg" className="border-border text-foreground hover:bg-accent hover:text-accent-foreground text-lg px-8 py-4 rounded-full" asChild>
                <Link to="/contact">Talk to sales</Link>
              </Button>
            </div>
            
            <p className="text-sm text-muted-foreground mt-6">
              No credit card required • Free 14-day trial • Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
